import {createSlice} from '@reduxjs/toolkit'
import { fetchBusinessType } from '../action/businessTypeMasterAction'

interface BusinessTypeState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: BusinessTypeState = {
  data: null,
  status: 'idle',
  error: null,
}

const businessTypeMasterSlice = createSlice({
  name: 'business',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessType.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchBusinessType.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchBusinessType.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default businessTypeMasterSlice.reducer
